import { render } from "./RegisterScreen.vue?vue&type=template&id=6792dff6"
import script from "./RegisterScreen.vue?vue&type=script&lang=js"
export * from "./RegisterScreen.vue?vue&type=script&lang=js"

import "./RegisterScreen.vue?vue&type=style&index=0&id=6792dff6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__